<template>
  <div>
    <a href="javascript:void(0)" class="d-block text-left esqueceu-senha" v-b-modal.modal-forgot-password>Esqueceu a senha?</a>

    <b-modal id="modal-forgot-password" ref="modalForgotPassword" title="Esqueceu a senha?" ok-title="Enviar" cancel-title="Voltar" @ok="passwordResetSolicitation">
      <div class="form-group">
        <label for="esqueci-senha">Vamos enviar agora mesmo para o seu e-mail!</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text text-center"><font-awesome-icon :icon="{ prefix: 'fa', iconName: 'at' }"/></div>
          </div>
          <input type="email" :class="($v.email.$error || apiValidationsEmailErrors)?'form-control is-invalid':'form-control'" id="esqueci-senha" placeholder="e-mail" name="email" v-model="email" required autofocus>
          <form-validation-invalid-feedback :field="$v.email" :text="{ email: 'Campo deve ser um email', required: 'Obrigatório informar o email' }" />
          <validation-message ref="validationMessageEmail"/>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import FormValidationInvalidFeedback from '@/components/formValidationInvalidFeedback'
import ValidationMessage from '@/components/validationMessage'

export default {
  name: 'ForgotPassword',
  components : {FormValidationInvalidFeedback, ValidationMessage},
  validations: {
    email: { required, email },
  },
  computed: {
    email: {
      get () {
        return this.$store.getters.emailForgotPassword
      },
      set (value) {
        this.$store.commit('setEmailForgotPassword', value)
      }
    },
    apiValidationsEmailErrors: {
      get () {
        if(this.$store.getters.errorsPasswordResetSolicitation?.validations?.email){
          return this.$store.getters.errorsPasswordResetSolicitation.validations.email[0]
        }else{
          return null
        }
      },
    }
  },
  watch: {
    '$store.getters.errorsPasswordResetSolicitation': function () {
      this.$refs.validationMessageEmail.dismissMessage()

      if(this.$store.getters.errorsPasswordResetSolicitation?.api){
        this.$toast.open({
          message: this.$store.getters.errorsPasswordResetSolicitation.api,
          type: 'error'
        })
      }

      if(this.$store.getters.errorsPasswordResetSolicitation?.validations){
        this.$refs.validationMessageEmail.showMessage(this.$store.getters.errorsPasswordResetSolicitation.validations.email[0])
      }

    }
  },
  methods: {
    async passwordResetSolicitation (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$v.$touch()

      if (!this.$v.$invalid) {
        let loader = this.$loading.show()

        await this.$store.dispatch('passwordResetSolicitation')

        if(!this.$store.getters.errorsPasswordResetSolicitation){
          this.$toast.open({
            message: 'Redefinição de senha enviado por email',
            type: 'success',
          })

          this.$nextTick(() => {
            this.$bvModal.hide('modal-forgot-password')
          })

        }

        loader.hide()
      }
    }  
  },
}
</script>